import { render } from "./Project.vue?vue&type=template&id=2c2452d4"
import script from "./Project.vue?vue&type=script&lang=js"
export * from "./Project.vue?vue&type=script&lang=js"

import "./Project.vue?vue&type=style&index=0&id=2c2452d4&lang=css"

import exportComponent from "D:\\eestec sajt trenutni\\eestec.etf.rs\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__